import Hero from './Comp_Hero.js';
import AboutBear from './Comp_AboutBear.js';
import Capabilities from './Comp_words.js';
import Contact from './Comp_Contact.js';
import React from "react";
import '../css/Home.css';

//IMAGES
import heroImg from '../img/home-hero.jpg';
import portrait from '../img/home-portrait.jpg';
import lens from '../img/home-lens.jpg';
import contactbg from '../img/home-seattle.jpg';

function HomePage() {
  return (
    <main className="pb-home">
      <Hero img={heroImg} />
      <AboutBear img={portrait} />
      <Capabilities img={lens} />
      <Contact img={contactbg} />
    </main>
  );
}

export default HomePage;
